var _defs, _path, _path2, _g, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #e47e1d;\n      }\n\n      .cls-3 {\n        fill: #c9e3f3;\n      }\n\n      .cls-4 {\n        fill: #c6ccd4;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M146,154.36V59c0-9.94-8.06-18-18-18h0c-9.94,0-18,8.06-18,18v95.36c-10.02,6.54-16.29,18.36-14.77,31.53,1.73,15.03,13.96,27.23,29,28.9,19.91,2.21,36.77-13.32,36.77-32.79,0-11.58-5.98-21.75-15-27.64Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M131,167.3v-63.3c0-1.66-1.34-3-3-3s-3,1.34-3,3v63.3c-6.85,1.39-12,7.44-12,14.7,0,8.28,6.72,15,15,15s15-6.72,15-15c0-7.26-5.15-13.31-12-14.7Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,56h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,71h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,86h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,101h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,116h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,131h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116,146h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140,68h6c1.66,0,3-1.34,3-3s-1.34-3-3-3h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146,77h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146,92h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146,107h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146,122h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146,137h-6c-1.66,0-3,1.34-3,3s1.34,3,3,3h6c1.66,0,3-1.34,3-3s-1.34-3-3-3Z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M128,218h0c-1.36,0-2.74-.08-4.1-.23-16.46-1.82-29.77-15.09-31.65-31.54-1.51-13.15,4.12-25.81,14.76-33.45V59c0-11.58,9.42-21,21-21s21,9.42,21,21v93.78c9.42,6.77,15,17.57,15,29.22,0,9.62-3.74,18.66-10.54,25.46-6.8,6.8-15.84,10.54-25.46,10.54Zm0-174c-8.27,0-15,6.73-15,15v96.98l-1.36,.89c-9.6,6.26-14.74,17.25-13.43,28.68,1.57,13.69,12.65,24.74,26.35,26.26,9.19,1.04,18.18-2.12,24.65-8.59,5.67-5.67,8.79-13.2,8.79-21.22,0-10.16-5.1-19.55-13.64-25.12l-1.36-.89V59c0-8.27-6.73-15-15-15Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemp);
export default __webpack_public_path__ + "static/media/temp.775c35f22669871a7d8a85a92d067ce2.svg";
export { ForwardRef as ReactComponent };